const PRoWDedicationCode = [
  {
    id: 1,
    gpText: "Footpath",
  },
  {
    id: 2,
    gpText: "Bridleway",
  },
  {
    id: 3,
    gpText: "Restricted Byway",
  },
  {
    id: 4,
    gpText: "Byway Open to All Traffic (BOAT)",
  },
  {
    id: 5,
    gpText: "Cycle Track or Cycle Way",
  },
  {
    id: 6,
    gpText: "Permissive Path",
  },
];

export default PRoWDedicationCode;